
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Industry = () => {
  return (
    <SettingsMetaData propertyName={"Industry_leads"} viewPropertyName={"Industry"} />
  );
};
export default Industry;
